(function() {

  var released = false;

  function releaseAll() {
    if (released) return;
    released = true;

    // 1. Restore real document.createElement
    if (window.__storeRealCreate) {
      document.createElement = window.__storeRealCreate;
    }

    // 2. Disconnect MutationObserver
    if (window.__storeObserver) {
      window.__storeObserver.disconnect();
    }

    // 3. Release all scripts held by createElement intercept
    //    (Meta Pixel, GTM, WPM, insurance widget etc.)
    var held = window.__storeHeld || [];
    held.forEach(function(item) {
      var fresh = window.__storeRealCreate('script');
      Array.from(item.el.attributes).forEach(function(attr) {
        fresh.setAttribute(attr.name, attr.value);
      });
      fresh.async = true;
      fresh.src = item.src;
      document.head.appendChild(fresh);
    });

    // 4. Release hardcoded Google Ads external script
    //    (was: <script defer src="googletagmanager.com/gtag/js?id=AW-...">)
    var gadsPlaceholder = document.getElementById('gads-placeholder');
    if (gadsPlaceholder) {
      var gAdsSrc = gadsPlaceholder.getAttribute('data-lazy');
      if (gAdsSrc) {
        var gadsScript = window.__storeRealCreate('script');
        gadsScript.async = true;
        gadsScript.src = gAdsSrc;
        document.head.appendChild(gadsScript);
        gadsPlaceholder.remove();
      }
    }

    // 5. Release hardcoded Google Ads inline config
    //    (was: <script>window.dataLayer... gtag('config', 'AW-...')</script>)
    var gadsInline = document.getElementById('gads-inline');
    if (gadsInline) {
      var inlineFresh = window.__storeRealCreate('script');
      inlineFresh.type = 'text/javascript';
      inlineFresh.innerHTML = gadsInline.innerHTML;
      gadsInline.remove();
      document.head.appendChild(inlineFresh);
    }

    // 6. Release lazy iframes
    document.querySelectorAll('iframe[data-lazy]').forEach(function(f) {
      f.src = f.getAttribute('data-lazy');
      f.removeAttribute('data-lazy');
    });

    // 7. Fire release event for rewired asyncLoad scripts
    document.dispatchEvent(new CustomEvent('asyncLazyLoad'));

    console.log('[Store] Scripts released. Count: ' + held.length);
  }

  // Trigger on first user interaction
  var events = [
    'mousedown', 'mousemove', 'keydown',
    'scroll', 'touchstart', 'click', 'touchmove'
  ];

  function onInteraction() {
    events.forEach(function(e) {
      window.removeEventListener(e, onInteraction, false);
    });
    releaseAll();
  }

  events.forEach(function(e) {
    window.addEventListener(e, onInteraction, false);
  });

  // Fallback — release 8 seconds after page load
  window.addEventListener('load', function() {
    setTimeout(releaseAll, 10000);
  });

})();